module.exports = __webpack_public_path__ + "img/JT-7-4-1-19a-no2.4b0952a2.jpg";